import jmin from './../support/jMin';
import Fields from './../support/Fields'

import DevStudio_Bar from './DevStudio_Bar'


export default class DevStudio {
	// Ajax request data
	requestParams = {}

	// Ajax request in progress
	requestProgress = 0

	// Ajax response
	response = {}

	// DevStudio bar
	Bar

	module
	conponent
	unit

	constructor() {

		this.fields = new Fields();

		document.addEventListener("DOMContentLoaded", () => {
			this.init();
		});
	}

	/**
	 * Init after content loaded
	 *
	 */
	init() {
		let _this = this;

		this.Bar = new DevStudio_Bar();

		// Bootstrap
		this.boot();

		// Unit on init
		if (DSData.options.general.appearance.unit_init) {
			[this.module, this.component, this.unit] = window.DSData.options.general.appearance.unit_init.split('.');
		}

		// Admin bar: show/hide UI
		jmin('#wp-admin-bar-dev-studio > a').on('click', function (e) {
			e.preventDefault();
			_this.UI();
		});

		//if (DSData.options.general.enabled == 'yes') {
		//DevStudio.UI();
		//}
	}

	/**
	 * Check boot status and process
	 *
	 */
	boot() {
		let boot = window.localStorage.getItem('dev-studio_boot');

		if (boot) {
			if (boot === 'open') {
				this.UI();
			}
		}

		window.localStorage.setItem('dev-studio_boot', '');
	}

	/**
	 * Load UI
	 *
	 */
	UI() {
		let el = document.querySelector('#dev-studio');
		if (!el) {
			this.request({request: 'UI', mode: DSData.mode}, function () {
				// Append UI to body
				let body = document.querySelector('body');
				body.insertAdjacentHTML('beforeend', this.response.html);

				// Init UI hamdlers
				this.initEventHandlers();

				this.setUIPosition();

				this.elDS.classList.add('ds-show');

				this.buildUI();
				this.loadData();
			});
		} else {
			el.classList.toggle('ds-show');
		}
	}

	/**
	 * Add live event handlers
	 *
	 */
	liveEventHandlers() {
		let _this = this;

		/**
		 * Tips
		 */
		/*
		jmin('#dev-studio .ds-icon-tip').on('click', function (e) {
			_this.showTip(this);
		});
		jmin('#dev-studio .ds-icon-tip').on('mouseover', function (e) {
			_this.showTip(this);
		});

		 */
	}

	/**
	 * Add init event handlers
	 *
	 */
	initEventHandlers() {
		let _this = this;

		if (window.DSData.options.bar.enabled === 'yes') {
			this.elDSBar = document.querySelector('#dev-studio-bar');
		}

		this.elDS = document.querySelector('#dev-studio');

		// Application turn off button
		jmin('#dev-studio .ds-on-off').on('click', function (e) {
			this.classList.toggle('ds-off');

			if (this.classList.contains('ds-off')) {
				_this.request({request: 'enabled', enabled: 'no'});

				window.setTimeout(() => {
					if (_this.elDS) _this.elDS.remove();
					if (_this.elDSBar) _this.elDSBar.remove();
				}, 600);
			} else {
				_this.elDS.classList.remove('ds-off');
			}
		});

		// Application turn on button
		jmin('#dev-studio #ds-on').on('click', function (e) {
			_this.request({request: 'enabled', enabled: 'yes'}, function (response) {
				window.localStorage.setItem('dev-studio_boot', 'open');
				window.location.reload();
			});
		});

		// AJAX mode
		jmin('#dev-studio .ds-slider.ds-ajax-on-off').on('click', function (e) {
			let $this = jmin(this);

			if ($this.hasClass('ds-off')) {
				// Turn On
				$this.removeClass('ds-off').addClass('ds-on');
				jmin('#ds-ajax').addClass('ds-active');
				jmin('#dev-studio #ds-ajax-test').addClass('ds-show');
			} else {
				// Turn Off
				$this.removeClass('ds-on').addClass('ds-off');
				jmin('#ds-ajax').removeClass('ds-active');
				jmin('#dev-studio #ds-ajax-test').removeClass('ds-show');
			}

			_this.closeCheckpoints();

			let mode = _this.mode();

			_this.module = null;
			_this.component = null;
			_this.unit = null;

			jmin('#dev-studio .ds-tabs-components .ds-component').removeClass('ds-active');
			jmin('#dev-studio .ds-tabs-units .ds-unit').removeClass('ds-active');

			// Update checkpoints select
			_this.updateCPSelect(DSData.options.checkpoints.actions[mode]);

			// Create actions list
			_this.setData('');

			_this.requestParams.noData = true;
			_this.ajaxTest( _this.ajaxTestCallback );

			//_this.request({request: 'actions', mode: mode}, _this.ajaxTestCallback );
			//_this.request({request: 'actions', mode: mode}, _this.updateActionsCallback);

			_this.buildUI();
		});

		// Ajax request test
		jmin('#dev-studio #ds-ajax-test div').on('click', () => {
			this.ajaxTest(this.ajaxTestCallback);
		});

		// Actions list
		jmin('#dev-studio .ds-checkpoints .ds-icon-checkpoints').on('click', function (e) {
			_this.toggleCheckpoints();
		});

		// Click on module tab
		jmin('#dev-studio .ds-tab-module').on('click', function (e) {
			if (jmin(this).hasClass('ds-active')) return;

			jmin('#dev-studio .ds-tab-module').removeClass('ds-active');
			jmin('#dev-studio .ds-tabs-components .ds-component').removeClass('ds-active');
			jmin('#dev-studio .ds-tabs-units .ds-unit').removeClass('ds-active');

			jmin(this).addClass('ds-active');

			if (jmin(this).hasClass('ds-tab-utilities')) {
				jmin('#dev-studio .ds-tabs-data .ds-tabs').addClass('ds-hide');
				jmin('#dev-studio .ds-tabs-data .ds-tabs-utilcats').removeClass('ds-hide');
				jmin('#dev-studio .ds-tabs-components').html('');
				jmin('#dev-studio .ds-tabs-data .ds-utilcat:first-child').addClass('ds-active');

				_this.setData('');
				_this.utilsShow();
			} else {
				jmin('#dev-studio .ds-tabs-data .ds-tabs').removeClass('ds-hide');
				jmin('#dev-studio .ds-tabs-data .ds-tabs-utilcats').addClass('ds-hide');

				_this.component = null;
				_this.unit = null;

				_this.buildUI();
				_this.loadData();
			}
		});

		// Checkpoints
		jmin('#dev-studio #checkpoint').on('change', function (e) {
			_this.buildUI();
			_this.loadData();
		});

		/**
		 * Tools
		 */
		// Info
		jmin('#dev-studio-tools .ds-app-info:not(.ds-active)').on('click', function (e) {
			let type = this.dataset.type;

			jmin('#dev-studio-tools > div').removeClass('ds-active');
			jmin(this).addClass('ds-active');

			_this.request({request: 'info', type: type}, function () {
				_this.setDataInfo(_this.response.html, type);
			});
		});

		// Settings
		jmin('#dev-studio-tools .ds-settings:not(.ds-active)').on('click', function (e) {
			_this.openSettings();
		});

		// Stats
		jmin('#dev-studio-tools .ds-stats:not(.ds-active)').on('click', function (e) {
			jmin('#dev-studio-tools > div').removeClass('ds-active');
			jmin(this).addClass('ds-active');

			_this.request({request: 'stats'}, function () {
				_this.setDataInfo(_this.response.html, 'stats');
			});
		});

		/**
		 * Data Info section
		 */
		let pin = window.localStorage.getItem('dev-studio_data-info');
		if (parseInt(pin) === 1) {
			jmin('#dev-studio .ds-data-info-control .ds-pin').addClass('ds-active');

			this.openDataInfo();
		}

		jmin('#dev-studio .ds-data-info-control .ds-pin').on('click', function (e) {
			this.classList.toggle('ds-active');

			if (this.classList.contains('ds-active')) {
				_this.openDataInfo();
				window.localStorage.setItem('dev-studio_data-info', 1);
			} else {
				_this.closeDataInfo();
				window.localStorage.setItem('dev-studio_data-info', 0);
			}
		});

		// Toggle data info section
		jmin('#dev-studio #dev-studio-tools .ds-toggle-info').on('click', function (e) {
			this.children[0].classList.contains('ds-icon-arrow_left')
				? _this.openDataInfo()
				: _this.closeDataInfo();
		});

		// Modal window
		jmin('#dev-studio .ds-modal .ds-icon-close, #dev-studio .ds-modal .ds-btn_close').on('click', function (e) {
			this.closest('.ds-modal').classList.remove('ds-show');
		});

		// Init dynamic handlers
		this.liveEventHandlers();

		// Init checkpoints list handlers
		this.actionsEventHandlers();

		// Init DataInfo block handlers
		this.dataInfoEventHandlers();
	}

	updateActionsCallback() {
		if (this.response.html) {
			document.querySelector('#dev-studio-actions').innerHTML = this.response.html;

			this.loadData();

			this.actionsEventHandlers();
		} else {
			//this.ajaxTest(this.ajaxTestCallback);
		}

		this.requestParams.noData = null;
	}

	/**
	 * Do test Ajax request
	 *
	 * @param callback
	 */
	ajaxTest(callback) {
		let args = {
			action: 'dev_studio_test',
			request: 'test',
			mode: 'ajax_' + window.DSData.mode
		}
		if (this.requestParams.noData) {
			args.no_data = 1;
		}

		this.request(args, callback);
	}

	ajaxTestCallback() {
		this.request({request: 'actions', mode: this.mode()}, this.updateActionsCallback);
	}

	/**
	 * Toggle checkpoints section
	 */
	toggleCheckpoints() {
		jmin('#dev-studio-actions').hasClass('ds-show') ? this.closeCheckpoints() : this.openCheckpoints();
	}

	/**
	 * Open checkpoints section
	 */
	openCheckpoints() {
		let _this = this, $cp = jmin('#dev-studio-actions');

		$cp.addClass('ds-show');

		this.closeDataInfo();

		jmin('#dev-studio .ds-tab-checkpoints').addClass('ds-active');
		document.querySelector('#dev-studio .ds-cp-wrap').style.display = 'flex';
	}

	/**
	 * Close checkpoints section
	 */
	closeCheckpoints() {
		let $cp = jmin('#dev-studio-actions');
		$cp.removeClass('ds-show');

		this.closeDataInfo();

		jmin('#dev-studio .ds-tab-checkpoints').removeClass('ds-active');
		document.querySelector('#dev-studio .ds-cp-wrap').style.display = 'none';
	}


	/**
	 * Add event handlers to Checkpoins section
	 *
	 */
	actionsEventHandlers() {
		let _this = this;

		// Actions carousel
		jmin('#dev-studio-actions .ds-cp-wrapper.start .ds-cp-start').on('click', function (e) {
			this.classList.toggle('expanded');
			jmin('#dev-studio-actions .ds-cp-not-available').toggleClass('ds-show');
		});

		// Enable/disable checkpoint
		jmin('#dev-studio .ds-cp-wrapper input[type="checkbox"]').on('click', function (e) {
			_this.updateCheckpoinsStatus();

			/*
			let cp = [];

			for (let el of document.querySelectorAll('#dev-studio .ds-cp-wrapper input[type="checkbox"]:checked')) {
				cp.push(el.dataset.action);
			}

			_this.request({request: 'checkpoints', cp: cp.join('::')}, function () {
				_this.updateCPSelect(_this.response.opts);

				window.DSData.options.checkpoints.actions[_this.mode()] = _this.response.opts;

				window.location.reload();
			});
			 */
		});

		// Save checkpoints and reload page
		jmin('#dev-studio #ds-btn_save_checkpoints').on('click', function (e) {
			let cp = [];

			for (let el of document.querySelectorAll('#dev-studio .ds-cp-wrapper input[type="checkbox"]:checked')) {
				cp.push(el.dataset.action);
			}

			_this.request({request: 'checkpoints', cp: cp.join('::')}, function () {
				_this.updateCPSelect(_this.response.opts);

				window.DSData.options.checkpoints.actions[_this.mode()] = _this.response.opts;

				window.location.reload();
			});
		});

		// Set or Remove disable attrivute
		this.updateCheckpoinsStatus();
	}

	/**
	 * Set or Remove disable attribute for checkpoint checkboxes.
	 * Limit in 3 checkpoints
	 */
	updateCheckpoinsStatus() {
		let count = jmin('#dev-studio .ds-cp-wrapper input[type="checkbox"]:checked').elements.length;

		jmin('#dev-studio .ds-cp-wrapper input[type="checkbox"]:not(:checked)').each((el) => {
			count >= 3 ? el.setAttribute('disabled', 'disabled') : el.removeAttribute('disabled');
		});
	}

	/**
	 * Add event handlers to Data section
	 *
	 */
	dataEventHandlers() {
		let _this = this;

		// Data filters
		jmin('#dev-studio .ds-filter-select, #dev-studio .ds-filter-checkbox').on('change', function (e) {
			let src = this.dataset.src, src_data = this.dataset.src_data, src_value = this.dataset.src_value;

			// Clear another filters
			jmin('#dev-studio .ds-filter-select').not(this).val('');
			jmin('#dev-studio .ds-filter-checkbox').not(this).each(function (el) {
				el.checked = false;
			});

			// Filter rows
			let rows = [];
			if (src === 'data') {
				rows = document.querySelectorAll('#dev-studio #dev-studio-data tbody tr[data-' + src_data + ']');
			}

			let filter_value = '';
			if (this.classList.contains('ds-filter-select')) {
				filter_value = this.value;
			} else if (this.classList.contains('ds-filter-checkbox')) {
				filter_value = this.checked ? this.value : '';
			}

			if (rows.length > 0) {
				for (let el of rows) {
					el.classList.remove('ds-active');
				}
			}

			if (filter_value === '') {
				for (let row of rows) {
					row.classList.remove('ds-hide');
				}
			} else {
				// Source: data attribute
				if (src === 'data') {
					let pos = 0;

					for (let row of rows) {
						let row_value = row.dataset[src_data];

						if (row_value === filter_value) {
							row.classList.remove('ds-hide');

							for (let td of row.children) {
								if (td.classList.contains('ds-pos')) {
									td.innerHTML = ++pos;
								}
							}
						} else {
							row.classList.add('ds-hide');
						}
					}

				}
			}

			// Order table
			jmin('#dev-studio th.ds-order.ds-active').each(function (el) {
				_this.orderTable(el.parentNode.parentNode.parentNode);
			});
		});

		// Order table data
		jmin('#dev-studio th.ds-order:not(.ds-disabled)').on('click', function (e) {
			let table = this.closest('table');
			let thead = table.querySelector('thead');

			this.classList.add('ds-disabled');


			let c = jmin(thead)
				.find('th').not(this).removeClass('ds-active ds-order-down ds-order-up')
				.children('.ds-icon').removeClass('ds-icon-arrow_down ds-icon-arrow_up').addClass('ds-icon-sort');

			if (jmin(this).hasClass('ds-order-up')) {
				jmin(this)
					.removeClass('ds-order-up').addClass('ds-active ds-order-down')
					.find('.ds-icon').removeClass('ds-icon-arrow_up ds-icon-arrow_sort').addClass('ds-icon-arrow_down')
			} else if (jmin(this).hasClass('ds-order-down')) {
				jmin(this)
					.removeClass('ds-active ds-order-down')
					.find('.ds-icon').removeClass('ds-icon-arrow_up ds-icon-arrow_down').addClass('ds-icon-sort')
			} else {
				jmin(this)
					.addClass('ds-active ds-order-up')
					.find('.ds-icon').removeClass('ds-icon-sort ds-icon-arrow_down').addClass('ds-icon-arrow_up')
			}

			_this.orderTable(table);

			this.classList.remove('ds-disabled');
		});

		// Show row info data
		jmin('#dev-studio .data-table span.row-info').on('click', function (e) {
			let id = this.dataset.id, type = this.dataset.type, table = this.closest('table');

			jmin(table).find('tr').removeClass('ds-active');
			this.closest('tr').classList.add('ds-active');

			_this.setDataInfo(
				jmin('#dev-studio #' + type + '-' + id).html()
			);
		});

		// Show info
		jmin('#dev-studio .data-table tr.info').on('click', function (e) {
			let id = this.dataset.id, table = this.closest('table');

			let isActive = this.classList.contains('ds-active');

			jmin(table).find('tr').removeClass('ds-active');

			if (isActive) {
				this.classList.remove('ds-active');
				_this.closeDataInfo();
			} else {
				this.classList.add('ds-active');
				_this.setDataInfo(
					jmin('#dev-studio #info' + '-' + id).html()
				);
			}
		});
	}

	/**
	 * Add event handlers to Data Info section
	 */
	dataInfoEventHandlers() {
		this.liveEventHandlers();
	}

	/**
	 * Open modal window
	 *
	 * @param html
	 * @param classes
	 */
	openModal(html, classes = '') {
		jmin('#dev-studio .ds-modal').addClass('ds-show');
		if (classes.trim() !== '') {
			jmin('#dev-studio .ds-modal').addClass(classes);
		}
		jmin('#dev-studio .ds-modal .ds-modal-content').html(html);
	}

	/**
	 * Open data info section
	 *
	 */
	openDataInfo() {
		jmin('#dev-studio #ds-data-container').addClass('ds-col-2');
		jmin('#dev-studio-tools .ds-toggle-info .ds-icon').removeClass('ds-icon-arrow_left').addClass('ds-icon-arrow_right');
	}

	/**
	 * Close data info section
	 *
	 */
	closeDataInfo() {
		jmin('#dev-studio #ds-data-container').removeClass('ds-col-2');
		jmin('#dev-studio-tools .ds-toggle-info .ds-icon').removeClass('ds-icon-arrow_right').addClass('ds-icon-arrow_left');
	}



	/*
	showTip(el) {
		let parent = el.parentNode, tip = parent.dataset.tip;

		if (tip !== undefined) {
			parent.insertAdjacentHTML('afterbegin', `<div class="ds-tip">${ tip }</div>`);
		}
	}
	 */

	/**
	 * Get current mode (admin|public)
	 *
	 */
	mode() {
		return this.is_ajax() ? 'ajax_' + DSData.mode : DSData.mode;
	}

	/**
	 * Is AJAX mode?
	 *
	 */
	is_ajax() {
		let el = document.querySelector('#dev-studio #ds-ajax');
		return el && el.classList.contains('ds-active');
	}

	/**
	 * Order data table
	 *
	 */
	orderTable(table) {
		let thead = table.children[0];

		let th;
		for (let el of thead.children[0].children) {
			if (el.classList.contains('ds-active')) {
				th = el;
			}
		}

		if (th) {
			// Get column index
			var index = 0, otype = '';
			for (let i = 0; i < thead.children[0].children.length; i++) {
				let th = thead.children[0].children[i];
				if (th.classList.contains('ds-active')) {
					index = i;
					otype = th.dataset.otype;
				}
			}

			// Sort rows
			let dir = th.classList.contains('ds-order-up') ? 'up' : 'down';
			this.orderColumns(table, index, dir, otype);
		} else {
			this.orderColumns(table, 0, 'default');
		}
	}

	/**
	 * Order data columns
	 *
	 */
	orderColumns(table, index, dir, type) {

		// Search not hidden rows
		let tbody = table.children[1], rows = [];
		for (let row of tbody.children) {
			if (!row.classList.contains('ds-hide')) {
				rows.push(row);
			}
		}

		let items = [];
		for (let row of rows) {
			let id = row.id, td = row.children[index];
			let value = dir !== 'default' ? td.innerHTML : row.dataset.pos;
			items.push({id, value});
		}

		type = typeof type === 'undefined' ? '' : type;

		if (type === '') {
			if (dir === 'down') {
				items.sort(this.sortStringDESC);
			} else {
				items.sort(this.sortStringASC);
			}
		}
		if (dir === 'default' || type === 'number') {
			if (dir === 'down') {
				items.sort(this.sortNumberDESC);
			} else {
				items.sort(this.sortNumberASC);
			}
		}

		// Sort rows
		var prevEl;
		items.forEach(function (el, index) {

			let swapEl;
			for (let row of rows) {
				if (row.id === el.id) swapEl = row;
			}

			for (let td of swapEl.children) {
				if (td.classList.contains('ds-pos')) {
					td.innerHTML = index + 1;
				}
			}

			if (!prevEl) {
				prevEl = rows[index];
				if (prevEl.id !== el.id) prevEl.before(swapEl);
			} else {
				prevEl.after(swapEl);
			}
			prevEl = swapEl;
		});
	}

	/**
	 * Sort strings ascending
	 *
	 * @param a
	 * @param b
	 * @returns {number}
	 */
	sortStringASC(a, b) {
		if (a['value'].toString().toUpperCase() < b['value'].toString().toUpperCase()) {
			return -1;
		}
		if (a['value'].toString().toUpperCase() > b['value'].toString().toUpperCase()) {
			return 1;
		}
		return 0;
	}

	/**
	 * Sort strings descending
	 *
	 * @param a
	 * @param b
	 * @returns {number}
	 */
	sortStringDESC(a, b) {
		if (a['value'].toString().toUpperCase() < b['value'].toString().toUpperCase()) {
			return 1;
		}
		if (a['value'].toString().toUpperCase() > b['value'].toString().toUpperCase()) {
			return -1;
		}
		return 0;
	}

	/**
	 * Sort numbers ascending
	 *
	 * @param a
	 * @param b
	 * @returns {number}
	 */
	sortNumberASC(a, b) {
		if (parseFloat(a['value']) < parseFloat(b['value'])) {
			return -1;
		}
		if (parseFloat(a['value']) > parseFloat(b['value'])) {
			return 1;
		}
		return 0;
	}

	/**
	 * Sort numbers descending
	 *
	 * @param a
	 * @param b
	 * @returns {number}
	 */
	sortNumberDESC(a, b) {
		if (parseFloat(a['value']) < parseFloat(b['value'])) {
			return 1;
		}
		if (parseFloat(a['value']) > parseFloat(b['value'])) {
			return -1;
		}
		return 0;
	}

	/**
	 * Clear application interface
	 *
	 */
	clearUI() {
		for (let el of document.querySelectorAll('#dev-studio .ds-tab-module, #dev-studio .ds-tabs-components .ds-component, #dev-studio .ds-tabs-units .ds-unit')) {
			el.classList.remove('ds-active');
		}
		this.setData('');
		this.setCondition();
	}

	/**
	 * Define top and bottom or interface
	 *
	 * @returns {{top: number, bottom: number}}
	 */
	getUIPosition() {
		let top = 0, bottom = 0;

		let adminBar = document.querySelector('#wpadminbar');
		if (adminBar) {
			top = adminBar.offsetHeight;
		}

		if (this.elDSBar) {
			top += this.elDSBar.offsetHeight;
		}
		return {top, bottom}
	}

	/**
	 * Set top and bottom of interface
	 *
	 */
	setUIPosition() {
		if (this.elDS) {
			let pos = this.getUIPosition();

			this.elDS.style.top = pos.top + 'px';
			this.elDS.style.bottom = pos.bottom + 'px';
		}
	}

	/**
	 * Put html to data section
	 *
	 * @param html
	 */
	setData(html) {
		document.querySelector('#dev-studio-data').innerHTML = html ? html : '';

		this.dataEventHandlers();
	}

	/**
	 * Put html to data info section
	 * 
	 * @param html
	 * @param mode
	 */
	setDataInfo(html, mode = '') {
		if (mode === '') {
			jmin('#dev-studio-tools > div').removeClass('ds-active');
		}

		jmin('#dev-studio-data-info .ds-data-info').html(html);
		if (html) {
			this.openDataInfo();
			this.dataInfoEventHandlers();
		}
	}

	/**
	 * Update checkpoints select
	 *
	 */
	updateCPSelect(cps) {
		let select = document.querySelector('#checkpoint'), val = select.value;
		select.innerHTML = '';

		if (cps) {
			for (const [key, elem] of Object.entries(cps)) {
				let el = document.createElement('option');
				el.value = key;
				el.text = key;
				select.append(el);
			}

			let selected = false;
			if (select.children.length > 0) {
				for (let option of select.children) {
					if (option.value === val) {
						option.selected = true;
						selected = true;
					}
				}
			}
			if (!selected) {
				select.selectedIndex = 0;
			}
		}
	}

	/**
	 * Build UI
	 *
	 */
	buildUI() {
		let _this = this;

		this.modules = document.querySelector('#dev-studio .ds-tabs-modules');
		this.components = document.querySelector('#dev-studio .ds-tabs-components');
		this.units = document.querySelector('#dev-studio .ds-tabs-units');

		if (!this.module || !this.component || !this.unit || !window.DSData.map[this.module]) {
			this.setCondition();
		}

		this.components.innerHTML = '';
		this.units.innerHTML = '';

		// Show components and units
		let comp_html = '', units_html = '';
		let module = window.DSData.map[this.module];

		if (module) {
			for (let [componentKey, component] of Object.entries(module.components)) {
				if (!this.component) this.component = componentKey;
				comp_html += '<div class="ds-component ' + (componentKey === this.component ? 'ds-active' : '') + '" data-component="' + componentKey + '">' + component.title + '</div>';

				if (componentKey === this.component) {
					for (const [unitKey, unit] of Object.entries(component.units)) {
						if (!this.unit) this.unit = unitKey;
						units_html += '<div class="ds-unit ' + (unitKey === this.unit ? 'ds-active' : '') + '" data-unit="' + unitKey + '">' + unit.title + '</div>';
					}
				}
			}
			this.components.innerHTML = comp_html;
			this.units.innerHTML = units_html;
		}

		// Activate first child if active is not exists
		/*
		if (jmin(this.components).find('.ds-component.ds-active').empty()) {
			let $comp = jmin(this.components).find('.ds-component:first-child');
			if (!$comp.empty()) {
				$comp.addClass('ds-active');
				
			}


		}
		
		 */

		// Add event hadlers to component tabs
		jmin('#dev-studio .ds-tabs-components .ds-component').on('click', function (e) {
			if (this.classList.contains('ds-active')) return;

			jmin('#dev-studio .ds-tabs-components .ds-component').removeClass('ds-active');
			jmin('#dev-studio .ds-tabs-units .ds-unit').removeClass('ds-active');

			this.classList.add('ds-active');

			_this.unit = null;

			_this.buildUI();
			_this.loadData();
		});

		// Add event hadlers to unit tabs
		jmin('#dev-studio .ds-tabs-units .ds-unit').on('click', function (e) {
			if (this.classList.contains('ds-active')) return;

			jmin('#dev-studio .ds-tabs-units .ds-unit').removeClass('ds-active');

			this.classList.add('ds-active');

			_this.unit = null;

			_this.setCondition();
			_this.loadData();
		});
	}

	/**
	 * Load data via Ajax
	 *
	 */
	loadData() {
		if (document.querySelector('#dev-studio.ds-show:not(.ds-off)')) {

			if (DSData.onOpen) {
				if (DSData.onOpen.startsWith('settings.')) {
					this.openSettings(DSData.onOpen);
				}
			} else {
				this.setData('');
				this.setCondition();

				let dot_unit = this.module + '.' + this.component + '.' + this.unit;

				this.request({
					request: 'data',
					checkpoint: document.querySelector('#checkpoint').value,
					dot_unit: dot_unit
				}, function () {
					this.setData(this.response.html);
				});
			}
		}
	}

	/**
	 * AJAX request
	 *
	 * @param args
	 * @param callback
	 */
	request(args, callback) {
		let data = {
			action: 'dev_studio',
			mode: this.mode(),
			nonce: window.DSData.ajax_nonce,
			request: ''
		}
		data = Object.assign({}, data, args);

		const formData = this.prepareFormData(data);

		// Fetch
		// Before send
		setTimeout(this.preloader.bind(this, true), 1000);
		this.requestProgress = true;

		fetch(window.DSData.ajax_url, {
			method: 'POST',
			credentials: 'same-origin',
			body: formData
		})
			.then((response) => response.json())
			.then((response) => {
				//console.log(response);

				this.response = response;

				if (response && response.result && response.result === 'ok') {
					if (typeof callback !== 'undefined') callback.apply(this, [response]);
				}
			})
			.then(() => {
				this.requestProgress = false;
				this.preloader(false);
			})
			.catch((error) => {
				console.log(error)
			});
	}

	buildFormData(formData, data, parentKey) {
		if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
			Object.keys(data).forEach(key => {
				this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
			});
		} else {
			const value = data == null ? '' : data;

			formData.append(parentKey, value);
		}
	}

	/**
	 * Prepare data for request
	 *
	 * @param data
	 * @returns {FormData}
	 */
	prepareFormData(data) {
		const formData = new FormData();

		this.buildFormData(formData, data);

		return formData;
	}

	/**
	 * Show / hide preloader
	 *
	 * @param show
	 */
	preloader(show) {
		let $preloader = jmin('#dev-studio .ds-preloader');

		if (!$preloader.empty()) {
			if (show) {
				if (this.requestProgress) {
					$preloader.addClass('ds-show');
				}
			} else {
				$preloader.removeClass('ds-show');
			}
		}
	}

	/**
	 * Define current application condition
	 *
	 */
	setCondition() {
		let el = document.querySelector('#dev-studio .ds-tab-module.ds-active');
		if (el) this.module = el.dataset.module;

		el = document.querySelector('#dev-studio .ds-tabs-components .ds-component.ds-active');
		if (el) this.component = el.dataset.component;

		el = document.querySelector('#dev-studio .ds-tabs-units .ds-unit.ds-active');
		if (el) this.unit = el.dataset.unit;
	}

	/**
	 * Open settings
	 *
	 * @param onOpen
	 */
	openSettings(onOpen) {
		let _this = this;

		jmin('#dev-studio-tools > div').removeClass('ds-active');
		jmin('#dev-studio-tools .ds-settings').addClass('ds-active');

		_this.request({request: 'settings'}, function () {
			_this.setDataInfo(_this.response.html, 'settings');

			for (const [key, elem] of Object.entries(_this.fields.handlers)) {
				elem.init();
			}

			_this.fields.eventHandlers();

			if (onOpen) {
				let map = onOpen.split('.');

				if (map[1]) {
					document.querySelector(`#dev-studio-data-info .dsf-nav-item[data-section=${map[1]}]`).click();
				}
				if (map[2]) {
					document.querySelector(`#dev-studio-data-info .dsf-nav-tab[data-tab=${map[2]}]`).click();
				}
			}

		});

	}
}
